
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Users, 
  FileText, 
  ClipboardList, 
  ClipboardCheck, 
  ActivitySquare, 
  File 
} from 'lucide-react';
import { 
  SidebarGroup, 
  SidebarGroupContent, 
  SidebarGroupLabel, 
  SidebarMenu, 
  SidebarMenuItem, 
  SidebarMenuButton 
} from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
import ROUTES from '@/routes-map';

const PatientsGroup: React.FC = () => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path);
  };

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Patients & Treatments</SidebarGroupLabel>
      <SidebarGroupContent>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.PATIENTS) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.PATIENTS}>
                <Users className="h-5 w-5" />
                <span>My Patients</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.TREATMENT_PLANS) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.TREATMENT_PLANS}>
                <FileText className="h-5 w-5" />
                <span>Treatment Plans</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.TREATMENT_SESSIONS) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.TREATMENT_SESSIONS}>
                <ClipboardList className="h-5 w-5" />
                <span>Treatment Sessions</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.FOLLOW_UP_REPORTS) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.FOLLOW_UP_REPORTS}>
                <ClipboardCheck className="h-5 w-5" />
                <span>Follow-up Reports</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.POST_TREATMENT_REPORTS) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.POST_TREATMENT_REPORTS}>
                <ActivitySquare className="h-5 w-5" />
                <span>Post-Treatment Reports</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
          
          <SidebarMenuItem>
            <SidebarMenuButton asChild className={cn(isActive(ROUTES.DOCTOR.MEDICAL_DOCUMENTS) && "bg-accent text-accent-foreground")}>
              <Link to={ROUTES.DOCTOR.MEDICAL_DOCUMENTS}>
                <File className="h-5 w-5" />
                <span>Medical Documents</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
};

export default PatientsGroup;
